export const typographyStyles = {
  // align
  left: 'text-left',
  center: 'text-center',

  // Weights
  regular: 'font-normal',
  medium: 'font-medium',
  bold: 'font-bold',

  // Text Colors
  t090: 'text-text-090',
  t070: 'text-text-070',
  t050: 'text-text-050',
  t010: 'text-text-010',
  tm050: 'text-main-050',
  tm090: 'text-main-090',
  tv090: 'text-variant-090',
  tc070: 'text-caution-070',
  white: 'text-white',

  //Styles
  underline: 'underline',

  //Title
  title1: 'header-1',
  title2: 'header-2',
  title3: 'header-3',

  //Body
  text1: 'body-1',
  text2: 'body-2',
  text3: 'body-3',

  //Caption
  cap1: 'caption-1',
  cap2: 'caption-2',
  cap3: 'caption-3',

  //Tint
  tint1: 'tint-1',
  tint2: 'tint-2'
}

export const levels = {
  caption1: typographyStyles.cap1,
  caption2: typographyStyles.cap2,
  caption3: typographyStyles.cap3,
  tint1: typographyStyles.tint1,
  tint2: typographyStyles.tint2,
  text1: typographyStyles.text1,
  text2: typographyStyles.text2,
  text3: typographyStyles.text3,
  title1: typographyStyles.title1,
  title2: typographyStyles.title2,
  title3: typographyStyles.title3
}

export const colors = {
  text090: typographyStyles.t090,
  text070: typographyStyles.t070,
  text050: typographyStyles.t050,
  text010: typographyStyles.t010,
  main050: typographyStyles.tm050,
  main090: typographyStyles.tm090,
  caution070: typographyStyles.tc070,
  white: typographyStyles.white
}

export const weights = {
  regular: typographyStyles.regular,
  medium: typographyStyles.medium,
  bold: typographyStyles.bold
}

export const styles = {
  underline: typographyStyles.underline
}

export const aligns = {
  left: typographyStyles.left,
  center: typographyStyles.center
}
